import Vue from 'vue'
import VueRouter from 'vue-router'
import SwaggerUI from './view/SwaggerUi'
import Usage from './view/Usage'

Vue.use(VueRouter)

const routes = [
  {
    name: 'root',
    path: '',
    component: SwaggerUI
  },
  {
    name: 'usage',
    path: '/usage',
    component: Usage
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
